<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :loading="loading ? '#0482fb' : null"
      :items="statbon"
      item-key="name"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing des Bon</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <!-- <v-switch
            v-model="showAllFil"
            label="Afficher toutes les données"
            color="#0482fb"
            @change="showAllFillData"
            class="pt-5"
          ></v-switch>
          <v-switch
            v-model="showYearFil"
            label="afficher les données de l'année "
            color="#0482fb"
            @change="showAllFillData"
            class="ml-10 pt-5"
          ></v-switch> -->
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche et importation vers excel ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-text-field
                    outlined
                    color="#0482fb"
                    label="Nom / Raison Sociale ..."
                    class="pt-5 pa-2"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    v-model="fileName"
                    flat
                    @change="onEnter"
                    background-color="grey lighten-4"
                  ></v-text-field>
                  <v-select
                    outlined
                    :items="companyNameList"
                    class="pt-5 pa-2"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    @change="onEnter"
                    v-model="company"
                    flat
                    background-color="grey lighten-4"
                    label="Compagnie ..."
                  ></v-select>
                  <v-text-field
                    outlined
                    color="#0482fb"
                    label="Date de demande Bon début ..."
                    class="pt-5 pa-2"
                    v-model="startDate"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    type="date"
                    @change="onEnter"
                    flat
                    background-color="grey lighten-4"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    color="#0482fb"
                    label="Date de demande bon fin ..."
                    class="pt-5 pa-2"
                    type="date"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    v-model="endDate"
                    @change="onEnter"
                    flat
                    background-color="grey lighten-4"
                  ></v-text-field>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="white--text mr-2"
                    color="#0482fb"
                    pill
                    @click="onEnter"
                  >
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>

                  <v-btn
                 
                    color="#1D6F42"
                    class="white--text pa-5"
                    :href="statFileBon"
                    target="_blank"
                  >
                    <v-icon size="30" class="mr-8" color="#fff" left>
                      mdi-microsoft-excel
                    </v-icon>
                    Exporter vers un tableau EXCEL
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { importDataExcel } from "../../exportDoc/index.js";
export default {
  name: "chartCall",
  data() {
    return {
      singleSelect: false,
      selected: [],
      loading: false,
      companyNameList: [],
      headers: [
        {
          text: "N° sinistre DAYO",
          align: "start",
          width: "200px",
          sortable: false,
          value: "sinisterAskNumber",
        },
        {
          text: "N° Sinistre compagnie",
          width: "200px",
          value: "sinisterCompanyNumber",
        },
        { text: "Nom / Raison sociale", width: "200px", value: "thirdName" },
        { text: "Nom compagnie", width: "200px", value: "company" },
        { text: "Date de demande Bon", width: "200px", value: "requestDateFr" },
        {
          text: "Date réception",
          width: "200px",
          value: "couponReceptionDateFr",
        },
        { text: "Montant", width: "200px", value: "amount" },
        { text: "Observations", width: "200px", value: "observation" },
      ],
      workSheetColumnName: [
        "N° sinistre DAYO",
        "N° Sinistre compagnie",
        "Nom / Raison sociale",
        "Nom compagnie",
        "Date de demande Bon",
        "Date réception",
        "Montant",
        "Observation",
      ],
      workSheetName: "Rapport Statistique BON",
      nombre: "bon",
      users: [],
    };
  },
  mounted() {
    this.initStatBon();
  },
  computed: {
    ...mapGetters(["statbon", "Companies", "statFileBon"]),
  },
  watch: {
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      // this.seedCoinsuranceCompanyNameList();
    },
  },

  methods: {
    importData() {
      //console.log(this.statCall);
      this.users = this.statbon;

      importDataExcel(
        this.workSheetColumnName,
        this.workSheetName,
        this.nombre,
        this.users
      );
    },
    showAllFillData() {
      this.initStatBon();
      //alert(this.showAllFil);
    },
    onEnter: function() {
      this.initStatBon();
    },
    ...mapActions(["getStateBon", "getCompanies"]),
    async initStatBon() {
      this.loading = true;
      try {
        await this.getStateBon({
          fileName: this.fileName,
          company: this.company,
          startDate: this.startDate,
          endDate: this.endDate,
          withoutPeriod: this.showAllFil,
          currentYear: this.showYearFil,
        });
        await this.getCompanies();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
  },
};
</script>
